import React, { FC, useEffect } from 'react';
import { isEmptyBlock } from '../../../../config/api/models/Block';
import { Loading } from '../../../shared/components';
import { EmptyPage } from './EmptyPage';
import { TrajectorySectionType } from '../../../../config/api/models/Trajectory';
import { BlocksList } from './BlocksList';
import { addBlock, fetchBlocks } from '../../../shared/slices/blocks/api/blocks';
import { useAppDispatch, useAppSelector } from '../../../shared/hooks/useAppDispatch';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { UrlParams } from 'src/modules/shared/types';
import { BlocksWrapper } from './Atoms';

type PageProps = {
  id: string;
  type?: string;
  readOnly?: boolean;
  bookId: string;
};

const Page: FC<PageProps> = ({ bookId, id, type, readOnly }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const blocks = useAppSelector((state) => state.blocks.blocks);
  const { seriesId } = useParams<UrlParams>();

  useEffect(() => {
    dispatch(fetchBlocks(id));
  }, [id, dispatch, seriesId]);

  useEffect(() => {
    if (readOnly || !type || !blocks) return;
    if (type !== 'worksheet_exercises') return;
    if (blocks.length > 0) return;

    dispatch(
      addBlock({
        bookId,
        pageId: id,
        payload: {
          type: 'wysiwyg',
          title: t(`trajectory.page.blocks.wysiwyg.title`),
          content: '',
        },
      })
    );
  }, [dispatch, readOnly, blocks, type, bookId, id, t]);

  const filteredBlocks = React.useMemo(() => {
    if (!blocks || blocks.length === 0) return [];

    if (!readOnly) return blocks;
    return blocks?.filter(block => !isEmptyBlock(block));
  }, [blocks, readOnly]);

  return (
    <>
      {blocks ? (
        <>
          {filteredBlocks.length > 0 ? (
            <BlocksWrapper>
              <BlocksList
                pageId={id}
                pageType={type as TrajectorySectionType}
                readOnly={readOnly}
                blocks={filteredBlocks}
              />
            </BlocksWrapper>
          ) : (
            <>
              {['opbouw', 'theory', 'study_guide'].includes(type as string) && (
                <EmptyPage id={id} />
              )}
            </>
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Page;
